import { ExpensesFilesFormFragment } from 'generated/resources/graphql'

type ExpensesFile = NonNullable<
  NonNullable<ExpensesFilesFormFragment['expense' | 'mileage' | 'perDiem']>['files']
>[number]

type FilesFormValues = {
  files: ExpensesFile[]
  filesIdToRemove: string[]
}

export const getFilesDefaultValues = (data?: ExpensesFilesFormFragment | null): FilesFormValues => {
  return {
    files: data?.expense?.files || data?.mileage?.files || data?.perDiem?.files || [],
    filesIdToRemove: [],
  }
}
